// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__DG8Nt","icon":"style_icon__2hT3g"};